import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  top: 0;
  height: 100%;
  
  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => theme.name !== 'blank' && css`
    top: ${theme.layout.container.top || '0'};
    height: ${theme.layout.container.height || '100%'};
  `}
`;

const Main = styled.div`
  height: 100%;
  
  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => theme.name !== 'blank' && css`
    height: ${theme.layout.main.height || '100%'};
  `}
`;

export const Layout = ({ children }) => {
  return (
    <Container>
      <Main>{children}</Main>
    </Container>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;

